/* Service Worker registration for Shakti Wings PWA */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Only register on production-like origins (https or localhost)
  const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  if (window.location.protocol !== "https:" && !isLocal) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Force an update check on every app boot so users get the latest SW
        // (otherwise a buggy old SW could keep intercepting requests forever).
        try { reg.update(); } catch {}
        // If a new SW is waiting (already downloaded), activate it immediately.
        if (reg.waiting) {
          try { reg.waiting.postMessage({ type: "SKIP_WAITING" }); } catch {}
        }
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              // New SW installed while old one still controls — tell it to skip waiting.
              try { installing.postMessage({ type: "SKIP_WAITING" }); } catch {}
            }
          });
        });
      })
      .catch((err) => {
        // Non-fatal — PWA still installable without SW caching, just silently log
        console.warn("[SW] registration failed:", err?.message || err);
      });

    // When a new SW takes control, reload once so all open tabs use fresh assets.
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });

    // Deployment version polling: long-lived sessions (TWA/Android app, tabs left
    // open for days) would otherwise keep running pre-redeploy code forever.
    // We compare the main.<hash>.js referenced by the live index.html with the one
    // this session loaded; on change we reload — but only when the app is hidden,
    // so an active member is never interrupted mid-action.
    let currentBuild = null;
    let pendingReload = false;
    const reloadWhenHidden = () => {
      if (document.hidden) { window.location.reload(); return; }
      pendingReload = true;
    };
    document.addEventListener("visibilitychange", () => {
      if (pendingReload && document.hidden) window.location.reload();
    });
    async function checkDeployment() {
      try {
        const res = await fetch("/", { cache: "no-store" });
        const html = await res.text();
        const m = html.match(/\/static\/js\/main\.([0-9a-f]+)\.js/);
        if (!m) return;
        if (currentBuild === null) { currentBuild = m[1]; return; }
        if (m[1] !== currentBuild) reloadWhenHidden();
      } catch { /* offline — try again next interval */ }
    }
    checkDeployment();
    setInterval(checkDeployment, 15 * 60 * 1000);
  });
}
